import * as Yup from 'yup'
import {IApplicationModel} from '../application/ApplicationModel'
import {ITagModel} from '../tag/TagModel'
import {ICallLogModel} from '../call-pool/CallPoolModel'

export const HR_CANDIDATE_PATH = '/hr/candidate'
export const candidateDetailPath = (id: string) => `${HR_CANDIDATE_PATH}/detail/${id}`

/** CandidateDto */
export interface ICandidateModel {
  id: string
  firstname: string
  lastname: string
  email?: string | null
  phone?: string | null
  candidateLocation?: string | null
  /** Güncel CV (son başvurudaki) */
  documentId?: string | null
  note?: string | null
  lastApplicationDate?: string | null
  applicationCount: number
  tags?: ITagModel[]
  createdDate?: string
  /** Yalnızca künyede dolu */
  applications?: IApplicationModel[]
  /** Yalnızca künyede dolu: arama kayıtları, en yenisi üstte */
  callLogs?: ICallLogModel[]
}

export interface ICandidateUpdateRequest {
  firstname: string
  lastname: string
  email: string
  phone: string
  candidateLocation: string
  note: string
}

export const validationCandidate = Yup.object().shape({
  firstname: Yup.string().trim().required('Ad zorunludur').max(100),
  lastname: Yup.string().trim().required('Soyad zorunludur').max(100),
  email: Yup.string().trim().email('Geçerli bir e-posta adresi giriniz').max(150),
  phone: Yup.string().trim().max(30),
  candidateLocation: Yup.string().trim().max(150),
  note: Yup.string().max(5000),
})

export const toCandidateForm = (candidate: ICandidateModel): ICandidateUpdateRequest => ({
  firstname: candidate.firstname ?? '',
  lastname: candidate.lastname ?? '',
  email: candidate.email ?? '',
  phone: candidate.phone ?? '',
  candidateLocation: candidate.candidateLocation ?? '',
  note: candidate.note ?? '',
})
